import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5b3708e2")

_pushScopeId("data-v-5b3708e2")
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "filter__item" }
const _hoisted_3 = /*#__PURE__*/_createVNode("span", { class: "filter__label" }, "À partir du: ", -1)
const _hoisted_4 = { class: "filter__item" }
const _hoisted_5 = /*#__PURE__*/_createVNode("span", { class: "filter__label" }, "Jusqu'au:", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_CheckboxFilter = _resolveComponent("CheckboxFilter")
  const _component_Datepicker = _resolveComponent("Datepicker")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_CheckboxFilter, {
      categories: _ctx.dates,
      selValues: _ctx.filterValues,
      invertible: false,
      collapsible: false,
      type: _ctx.RADIO,
      title: "Date",
      class: "filters filters--date",
      onUpdated: _ctx.updateFilterFromDispName
    }, null, 8, ["categories", "selValues", "type", "onUpdated"]),
    (_ctx.hasCustomFilterApplied)
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            _hoisted_3,
            _createVNode(_component_Datepicker, {
              modelValue: _ctx.startDateFilter,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.startDateFilter = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createVNode("div", _hoisted_4, [
            _hoisted_5,
            _createVNode(_component_Datepicker, {
              modelValue: _ctx.endDateFilter,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.endDateFilter = $event))
            }, null, 8, ["modelValue"])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
})